import React from 'react';
import { useTranslation } from 'react-i18next';

function toArray(value) {
  if (Array.isArray(value)) {
    return value;
  }
  return [];
}

export default function About() {
  const { t } = useTranslation();
  const sections = toArray(t('info.aboutPage.sections', { returnObjects: true }));

  return (
    <div className="container">
      {sections.map((section, idx) => {
        const paragraphs = toArray(section.paragraphs);
        const link = section.link;
        return (
          <section key={`about-section-${idx}`}>
            <h2>{section.title}</h2>
            {paragraphs.map((paragraph, pIdx) => (
              <p key={`about-section-${idx}-p-${pIdx}`}>{paragraph}</p>
            ))}
            {link && (
              <p>
                <a
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.label}
                </a>
              </p>
            )}
          </section>
        );
      })}
    </div>
  );
}
